import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from '../contexts/TranslationContext';

// Simplified Loading: always shows translated 'common.loading'
const Loading: React.FC = () => {
  const { t } = useTranslation();
  const displayMessage = t('common.loading');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" color="text.secondary">
        {displayMessage}
      </Typography>
    </Box>
  );
};

export default Loading;